<script setup lang="ts">
import DRBtn from "@/components/UI/DRBtn.vue";
import { useUpdateTemplateSettings } from "../../settings/useUpdateReportSettings";
import type { ReportTemplate } from "@/types/report-templates.types";
import { computed } from "vue";
import { useUpdateReportTemplate } from "@/stores/queries/report-templates.query";

const props = defineProps<{
  template: ReportTemplate;
}>();
const templateId = computed(() => props.template.id);
const templateSettings = computed(() => props.template?.settings);
const { mutate, isPending } = useUpdateReportTemplate(templateId);

const { isChanges, submit } = useUpdateTemplateSettings(
  templateSettings,
  (settings) => {
    mutate({ settings });
  }
);
</script>

<template>
  <DRBtn
    class="w-100"
    size="lg"
    icon="bi-save"
    :label="$t('saveModifications')"
    @click="submit"
    :disabled="!isChanges"
    :loading="isPending"
  >
  </DRBtn>
</template>

<style lang="scss" scoped></style>
